import React from 'react';
import A from './A';

export default function Check({ check, setCheck, children }) {
    return <A className="Check" onClick={() => setCheck(!check)}>{check?'✔':''} {children}</A>
}